import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from 'config/api';

export const reviewsApi = createApi({
  reducerPath: 'reviewsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
  }),
  tagTypes: ['Reviews'],
  endpoints: (build) => ({
    getReviews: build.query({
      query: () => ({
        url: 'review',
      }),
    }),
  }),
});

export const { useGetReviewsQuery } = reviewsApi;

export default reviewsApi;
